import { serverSidePagePrepare } from "@lib/hooks"
import { observer } from "mobx-react"
import {
  DocumentTemplate,
  Header,
  Page,
  PureLogo,
  useStore,
} from "@features/common"
import { RouterLink } from "@lib/routing"
import { scrollToTop } from "@lib/scroll"
import { IconHamburger } from "@lib/icons"
import { RichContentView } from "@ui"

export const getServerSideProps = serverSidePagePrepare({
  callback: async ({ Models }) => {
    await Models.LegalModel.getAccountDeletionPageData()
  },
})

const AccountDeletionPage = observer(function AccountDeletionPage() {
  const {
    GlobalModel: { openMenu },
    LegalModel: { accountDeletionText, accountDeletionTitle },
  } = useStore()

  return (
    <Page
      meta={{
        title: accountDeletionTitle,
      }}
      header={
        <Header
          theme="dark"
          logo={
            <RouterLink
              uri="/legal/google-account-deletion"
              onClick={() => scrollToTop()}
              data-test-id="header__pure_logo"
              aria-label="root"
              className="mt-4 mb-3 tablet-m:mt-[20px] tablet-m:mb-[18px]"
            >
              <div className="shrink-0 flex items-stretch h-4 tablet-m:h-7">
                <PureLogo className="shrink-0 block h-full w-auto tablet:h-full text-white pr-2 tablet-m:pr-4" />
              </div>
            </RouterLink>
          }
          languageSwitcher={null}
          navigationOpener={
            <button
              onClick={openMenu}
              data-test-id="header__menu_button"
              aria-label="menu"
            >
              <IconHamburger className="w-8 h-8 text-white" />
            </button>
          }
        />
      }
      seoH1={accountDeletionTitle}
    >
      <div className="container pt-3 pb-15 laptop:pt-8 laptop:pb-20 legal-document account-deletion">
        <DocumentTemplate>
          <section className="space-y-10" id="scrollContainerElement">
            <RichContentView src={accountDeletionText} />
          </section>
        </DocumentTemplate>
      </div>
    </Page>
  )
})

export default AccountDeletionPage
